export default {
  id: 'integrations',
  title: 'Integrations',
  category: 'Admin',
  summary: 'Connect Timeclerk with external systems such as QuickBooks and Paylocity.',
  overview: 'Integrations keep accounting and payroll systems aligned with Timeclerk. Each provider has capability pages for mapping entities and reviewing synced transactions or payroll.',
  howItWorks: [
    'Choose an integration provider from the hub.',
    'Map Timeclerk entities (customers, contracts, projects, charge codes, employees, payroll expenses) to external counterparts.',
    'Sync or import transactions and payroll according to the provider’s workflow.',
    'Review connection status and fix mapping gaps when sync issues appear.'
  ],
  actions: [
    {
      name: 'Open QuickBooks',
      description: 'Manage entity mappings and review QuickBooks transactions.'
    },
    {
      name: 'Open Paylocity',
      description: 'Manage employee mapping, test connectivity, and work with payroll import/schedule capabilities.'
    }
  ],
  tips: [
    'Complete mappings before running bulk syncs to avoid misposted transactions.',
    'After structural changes in Timeclerk (new customers/projects), revisit mappings.'
  ],
  related: ['quickbooks', 'paylocity', 'invoices', 'payroll']
};



// WEBPACK FOOTER //
// ./client/help/content/integrations.js